// Remembers where to send the user once they have logged in, for pages that
// are reached from outside the portal (the OAuth consent page Claude opens).
// Only same-origin paths are kept, so this can never become an open redirect.

const KEY = 'postLoginRedirect';

const isSafePath = (path: string): boolean => path.startsWith('/') && !path.startsWith('//');

export const setPostLoginRedirect = (path: string): void => {
    if (!isSafePath(path)) return;
    try {
        sessionStorage.setItem(KEY, path);
    } catch {
        // Storage unavailable: the user lands on the start page after login.
    }
};

export const getPostLoginRedirect = (): string | null => {
    try {
        const path = sessionStorage.getItem(KEY);
        return path && isSafePath(path) ? path : null;
    } catch {
        return null;
    }
};

export const clearPostLoginRedirect = (): void => {
    try {
        sessionStorage.removeItem(KEY);
    } catch {
        // ignore
    }
};
